var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-input-error-messages",
      "title": _vm.$t('myAccount.systemConfigs.errorMessages.updateTitle'),
      "size": "xl",
      "centered": true,
      "scrollable": false,
      "hide-footer": true,
      "no-close-on-backdrop": true,
      "no-close-on-esc": true
    },
    on: {
      "show": _vm.showHandle
    }
  }, [_c('IAmOverlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('ValidationObserver', {
    ref: "refFormObserver"
  }, [_c('BTable', {
    staticClass: "table-sm",
    attrs: {
      "items": _vm.errorListToEdit,
      "fields": _vm.columns,
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "responsive": "",
      "show-empty": "",
      "empty-text": _vm.$t('myAccount.systemConfigs.errorMessages.emptyData')
    },
    scopedSlots: _vm._u([{
      key: "cell(index)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.index + 1) + " ")];
      }
    }, {
      key: "cell(key)",
      fn: function fn(data) {
        return [_c('ValidationProvider', {
          staticClass: "w-100",
          attrs: {
            "name": "key",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref) {
              var errors = _ref.errors;
              return [_c('BFormInput', {
                staticClass: "d-none",
                attrs: {
                  "value": data.item.key
                }
              }), _c('IAmInputTextOrTextarea', {
                attrs: {
                  "id": "key-".concat(data.index),
                  "text": data.item.key,
                  "name": "key",
                  "autocomplete": "off",
                  "lengthBreak": 40,
                  "state": errors.length > 0 ? false : null,
                  "placeholder": _vm.$t('myAccount.systemConfigs.errorMessages.keyPlaceholder')
                },
                on: {
                  "update:text": function updateText($event) {
                    return _vm.$set(data.item, "key", $event);
                  }
                }
              }), errors.length > 0 ? _c('BTooltip', {
                staticClass: "tooltip-error",
                attrs: {
                  "title": errors[0],
                  "variant": "danger",
                  "target": "key-".concat(data.index)
                }
              }, [_vm._v(" " + _vm._s(errors[0]) + " ")]) : _vm._e()];
            }
          }], null, true)
        })];
      }
    }, {
      key: "cell(viValue)",
      fn: function fn(data) {
        return [_c('ValidationProvider', {
          staticClass: "w-100",
          attrs: {
            "name": "vi",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var errors = _ref2.errors;
              return [_c('BFormInput', {
                staticClass: "d-none",
                attrs: {
                  "value": data.item.viValue
                }
              }), _c('IAmInputTextOrTextarea', {
                attrs: {
                  "id": "vi-".concat(data.index),
                  "text": data.item.viValue,
                  "name": "vi",
                  "autocomplete": "off",
                  "lengthBreak": 40,
                  "state": errors.length > 0 ? false : null,
                  "placeholder": _vm.$t('myAccount.systemConfigs.errorMessages.viPlaceholder')
                },
                on: {
                  "update:text": function updateText($event) {
                    return _vm.$set(data.item, "viValue", $event);
                  }
                }
              }), errors.length > 0 ? _c('BTooltip', {
                staticClass: "tooltip-error",
                attrs: {
                  "title": errors[0],
                  "variant": "danger",
                  "target": "vi-".concat(data.index)
                }
              }, [_vm._v(" " + _vm._s(errors[0]) + " ")]) : _vm._e()];
            }
          }], null, true)
        })];
      }
    }, {
      key: "cell(value)",
      fn: function fn(data) {
        return [_c('ValidationProvider', {
          staticClass: "w-100",
          attrs: {
            "name": "en",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var errors = _ref3.errors;
              return [_c('BFormInput', {
                staticClass: "d-none",
                attrs: {
                  "value": data.item.value
                }
              }), _c('IAmInputTextOrTextarea', {
                attrs: {
                  "id": "en-".concat(data.index),
                  "text": data.item.value,
                  "name": "en",
                  "autocomplete": "off",
                  "lengthBreak": 40,
                  "state": errors.length > 0 ? false : null,
                  "placeholder": _vm.$t('myAccount.systemConfigs.errorMessages.enPlaceholder')
                },
                on: {
                  "update:text": function updateText($event) {
                    return _vm.$set(data.item, "value", $event);
                  }
                }
              }), errors.length > 0 ? _c('BTooltip', {
                staticClass: "tooltip-error",
                attrs: {
                  "title": errors[0],
                  "variant": "danger",
                  "target": "en-".concat(data.index)
                }
              }, [_vm._v(" " + _vm._s(errors[0]) + " ")]) : _vm._e()];
            }
          }], null, true)
        })];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('HStack', [_c('BButton', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top.window.dark",
            value: _vm.$t('myAccount.systemConfigs.errorMessages.deleteRow'),
            expression: "$t('myAccount.systemConfigs.errorMessages.deleteRow')",
            modifiers: {
              "hover": true,
              "top": true,
              "window": true,
              "dark": true
            }
          }],
          staticClass: "rounded p-50",
          attrs: {
            "variant": "flat-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.onDeleteRow(data.index);
            }
          }
        }, [_c('IAmIcon', {
          attrs: {
            "icon": "closeOutline",
            "size": "16"
          }
        })], 1)], 1)];
      }
    }])
  }), _c('BRow', [_c('BCol', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "Api key",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('HStack', {
          attrs: {
            "center": ""
          }
        }, [_c('BFormInput', {
          staticClass: "flex-1",
          attrs: {
            "id": "api-key-input",
            "name": "Api key",
            "type": _vm.isShowApiKeys ? 'text' : 'password',
            "autocomplete": "false",
            "placeholder": _vm.$t('myAccount.systemConfigs.errorMessages.apiKeyInput'),
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.apiKeys,
            callback: function callback($$v) {
              _vm.apiKeys = $$v;
            },
            expression: "apiKeys"
          }
        }), _c('BButton', {
          staticClass: "btn-icon p-50 rounded-circle",
          attrs: {
            "variant": "flat-primary"
          },
          on: {
            "click": function click($event) {
              _vm.isShowApiKeys = !_vm.isShowApiKeys;
            }
          }
        }, [_c('IAmIcon', {
          attrs: {
            "icon": _vm.isShowApiKeys ? 'eye' : 'eyeClose'
          }
        })], 1), errors.length > 0 ? _c('BTooltip', {
          staticClass: "tooltip-error",
          attrs: {
            "title": errors[0],
            "variant": "danger",
            "target": "api-key-input"
          }
        }, [_vm._v(" " + _vm._s(errors[0]) + " ")]) : _vm._e()], 1)];
      }
    }])
  })], 1), _c('BCol', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('HStack', {
    staticClass: "gap-2",
    attrs: {
      "center": ""
    }
  }, [_c('BButton', {
    staticClass: "px-75",
    attrs: {
      "variant": "flat-secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-input-error-messages');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('close')) + " ")]), _c('BButton', {
    staticClass: "px-75",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": _vm.onClickUpdate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('myAccount.systemConfigs.errorMessages.update')) + " ")])], 1)], 1), _c('BCol', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('HStack', {
    attrs: {
      "end": ""
    }
  }, [_c('BButton', {
    staticClass: "px-75",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": _vm.onAddRow
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('myAccount.systemConfigs.errorMessages.addRow')) + " ")])], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }